// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles_icon__svaC6","dot":"styles_dot__FbJan","signers":"styles_signers__lNNaR"};